import { colors, Text, TextProps } from "@biblioteksentralen/react";
import { Event } from "@libry-content/types";
import { useTranslation } from "../../utils/hooks/useTranslation";

const stylesProps: TextProps = { fontWeight: "semibold" };

const RegistrationStatus = ({ registration }: Pick<Event, "registration">) => {
  const { t } = useTranslation();

  if (registration === "registration") {
    return (
      <Text color={colors.statusYellow} {...stylesProps}>
        {t("Gratis - krever påmelding")}
      </Text>
    );
  }

  if (registration === "ticket") {
    return (
      <Text color={colors.statusYellow} {...stylesProps}>
        {t("Arrangementet krever billett")}
      </Text>
    );
  }

  return (
    <Text color={colors.statusGreen} {...stylesProps}>
      {t("Gratis - ingen påmelding")}
    </Text>
  );
};

export default RegistrationStatus;
